// =============================================================================
// paginadatosProd.js - Versión Homologada con Persistencia Permanente
// =============================================================================
import { mostrarToast, obtenerUrlBackend } from './utilerias.js';
import { GestorGrafica } from './graficaModulo.js';

export function paginadatosProd() {
    const html = `
        <div class="container-fluid"> 
            <div id="estado-contenedor" class="alert alert-info" role="alert">
                <p id="mensaje-estado" class="mb-0">Cargando datos del servidor...</p>
            </div>

            <div class="table-responsive">
                <table id="tabla-filtros" class="table table-striped table-hover w-100">
                    <thead class="table-light">
                        <tr>
                            <th>Área</th>
                            <th>LP</th>
                            <th>Proceso</th>
                            <th>Grupo</th>
                            <th>Subgrupo</th>
                            <th>UM</th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>   
        </div>

      <div class="modal modal-corporativo" id="prod-modalGraficaSelector" data-bs-backdrop="false" tabindex="-1" aria-labelledby="prod-modalGraficaSelectorLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="d-flex align-items-center">
                        <h5 class="modal-title" id="prod-modalGraficaSelectorLabel">Selección de Métricas Mensuales</h5>
                        <button type="button" class="btn btn-sm btn-outline-light ms-3" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#prod-cont-seleccion-metricas" 
                            aria-expanded="false" 
                            aria-controls="prod-cont-seleccion-metricas">
                            <i class="fa-solid fa-sliders me-1"></i> Parámetros
                        </button>
                    </div>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div id="tabla-filtros-grafico" class="mb-3" style="display:none;">
                        <table class="table table-sm table-bordered small text-center bg-white">
                            <thead class="table-secondary">
                                <tr>
                                    <th>Área</th>
                                    <th>LP</th>
                                    <th>Proceso</th>
                                    <th>Grupo</th>
                                    <th>UM</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td id="filtro-area-valor">-</td>
                                    <td id="filtro-lp-valor">-</td>
                                    <td id="filtro-proceso-valor">-</td>
                                    <td id="filtro-grupo-valor">-</td>
                                    <td id="filtro-um-valor">-</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div id="prod-cont-seleccion-metricas" class="collapse border-bottom pb-3 mb-3">
                        <div class="card card-body bg-light">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <h6><i class="fa-solid fa-calendar-range"></i> Rango de Periodo:</h6>
                                    <div class="row mb-3">
                                        <div class="col-12 col-sm-6 mb-2">
                                            <label for="prod-fecha-inicio" class="form-label small">Desde:</label>
                                            <input type="month" id="prod-fecha-inicio" class="form-control">
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <label for="prod-fecha-fin" class="form-label small">Hasta:</label>
                                            <input type="month" id="prod-fecha-fin" class="form-control">
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-2 fw-bold text-center" style="font-size: 0.8rem; color: #666;">
                                    <div class="col-6 text-start">Concepto</div>
                                    <div class="col-3">Promedio</div>
                                    <div class="col-3">Real</div>
                                     <div class="col-12" style="height: 25px; border-bottom: 2px solid #dee2e6;"></div>
                                </div>
                                <div id="lista-metricas-checkboxes"></div>
                            </div>

                            <div class="text-end mt-3">
                                <button type="button" class="btn btn-success btn-sm" id="btn-gen-graf">
                                    <i class="fa-solid"></i> Generar Gráfica
                                </button>
                            </div>
                        </div>
                    </div>

                    <div id="estado-modal" class="alert alert-info py-2 small" role="alert" style="display:none;"></div>

                    <div id="contenedor-grafico" style="height: 320px; width: 100%; display:none;">
                        <canvas id="grafica-seleccionada"></canvas>
                    </div>

                    <div class="table-responsive mt-3" id="tabla-datos-semanas" style="display:none; max-height: 150px; overflow-x: auto;">
                        <table class="table table-sm table-bordered" style="font-size: 11px; white-space: nowrap;">
                            <thead id="thead-semanas"></thead>
                            <tbody id="tbody-semanas"></tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                </div>
            </div>
        </div> 
    </div>
    `;

    setTimeout(() => {
        graficaArticulos = new GestorGrafica({
            idInicio: 'prod-fecha-inicio',
            idFin: 'prod-fecha-fin',
            idContenedorMetricas: 'lista-metricas-checkboxes',
            idCanvas: 'grafica-seleccionada',
            storageKey: 'preferenciasGraficaProduccion', 
            selectorCheckboxes: '.prod-metrica-selector'
        });
        obtenerYRenderizarFiltros();
    }, 100);

    return html;
}

const URL_BASE_API = obtenerUrlBackend('8083');
const URL_API = `${URL_BASE_API}/api/datosProd`;
const URL_API_FILTROS = `${URL_BASE_API}/api/datosProd/filtros`;

let graficaArticulos = null; 

async function obtenerYRenderizarFiltros() {
    const mensajeEstado = document.getElementById('mensaje-estado');
    const estadoContenedor = document.getElementById('estado-contenedor');

    mensajeEstado.textContent = "Cargando datos...";
    
    try {
        const token = sessionStorage.getItem('token_teresita');

        const respuesta = await fetch(URL_API, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        });

        if (!respuesta.ok) {
            if (respuesta.status === 401 || respuesta.status === 403) {
                throw new Error("Sesión inválida o expirada. Por favor, inicia sesión de nuevo.");
            }
            throw new Error(`Error en el servidor: ${respuesta.status}`);
        }

        const datos = await respuesta.json();

        if (datos.length === 0) {
            throw new Error("No se encontraron registros.");
        }

        inicializarDataTable(datos);
        mensajeEstado.textContent = `✅ Mostrando ${datos.length} combinaciones.`;
        
    } catch (error) {
        console.error("Fallo al obtener datos:", error);
        mostrarToast(error.message, 'warning'); 
        if (estadoContenedor) {
            estadoContenedor.className = 'alert alert-danger';
            mensajeEstado.textContent = `❌ ${error.message}`;
        }
    }
}

function inicializarDataTable(datos) {
    if ($.fn.DataTable.isDataTable('#tabla-filtros')) {
        $('#tabla-filtros').DataTable().destroy();
    }

    if (!document.getElementById('prod-custom-styles')) {
        const style = document.createElement('style');
        style.id = 'prod-custom-styles';
        style.innerHTML = `
            #tabla-filtros td { white-space: nowrap !important; }
            .filtro-container-celda { margin-top: 5px; }
        `;
        document.head.appendChild(style);
    }

    const columnasDef = [
        { data: 'tp01_ct', title: 'Área' },
        { data: 'tp01_prod_line', title: 'LP' },
        { data: 'tp01_proceso', title: 'Proceso' },
        { data: 'tp01_producto', title: 'Grupo', defaultContent: '-', render: data => data || '-' },
        { data: 'tp01_grupo', title: 'Subgrupo', defaultContent: '-', render: data => data || '-' },
        { data: 'tp01_um', title: 'UM' }
    ];

    const table = $('#tabla-filtros').DataTable({
        data: datos,
        columns: columnasDef,
        language: { url: "https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json" },
        paging: true,
        order: [[0, 'asc']],
        searching: true,
        scrollX: true,        // ✅ Añadido scroll horizontal homologado
        autoWidth: false,
        retrieve: true,
        stateSave: true,      // ✅ Añadido almacenamiento nativo de estado
        stateDuration: 0,     // ✅ Configurado persistente permanente (localStorage)
        responsive: false,     // ✅ Cambiado a false para que conviva correctamente con scrollX
        lengthChange: true,
        pageLength: 25,
        lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "Todos"]],
        dom: '<"row mb-3 align-items-center" <"col-sm-6"B> <"col-sm-6 text-end"l> >rt<"row" <"col-sm-6"i> <"col-sm-6"p> >',
        buttons: [
            { 
                extend: 'colvis', 
                text: '<i class="fas fa-binoculars fa-lg"></i> Columnas', 
                className: 'btn btn-sm',
                postfixButtons: [
                    { 
                        extend: 'colvisRestore',
                        text: '<i class="fas fa-eye"></i> Mostrar Todas',
                        action: function (e, dt, node, config) {
                        
                        dt.columns().visible(true);
                        dt.state.save();
                        dt.columns.adjust().draw(false);
                        
                        setTimeout(function() {
                            dt.columns.adjust();
                        }, 100);
                        }
                    }
                ]
            },            
            {
                extend: 'collection',
                text: '<i class="fas fa-download"></i> Exportar', 
                className: 'btn btn-sm',   
                buttons: [
                    { extend: 'copy', text: '<i class="fas fa-copy"></i> Copiar', exportOptions: {columns: ':visible'} },
                    { extend: 'excel', text: '<i class="fas fa-file-excel"></i> Excel', exportOptions: {columns: ':visible'} },
                    { extend: 'pdf', text: '<i class="fas fa-file-pdf"></i> PDF', orientation: 'landscape', exportOptions: {columns: ':visible'} },
                    { extend: 'print', text: '<i class="fas fa-print"></i> Imprimir', exportOptions: {columns: ':visible'} }
                ]
            },
            {
                text: '<i class="fas fa-filter"></i> Limpiar Filtros', 
                className: 'btn btn-sm',
                action: function (e, dt) {
                    $('.filtro-columna').val('');
                    dt.columns().every(function () {
                        this.search(''); 
                    });
                    dt.search('').draw(); 
                }
            }
        ],
        initComplete: function () {
            var api = this.api();
            var estadoCargado = api.state.loaded(); // ✅ Recupera caché guardado de filtros

            api.columns().every(function (i) {
                var column = this;
                var headerCelda = $(column.header());
                
                if (headerCelda.find('.filtro-container-celda').length > 0) {
                    return;
                }

                var title = api.settings()[0].aoColumns[i].sTitle || headerCelda.text();
                
                var container = $('<div class="filtro-container-celda mt-1"></div>');
                var input = $('<input type="text" class="filtro-columna form-control form-control-sm" placeholder="Filtrar ' + title + '" style="font-weight: normal;" />');
                
                // ✅ REINJECTAR VALOR HISTÓRICO SI EXISTÍA EN LOCALSTORAGE
                if (estadoCargado && estadoCargado.columns[i] && estadoCargado.columns[i].search.search) {
                    input.val(estadoCargado.columns[i].search.search);
                }

                input.appendTo(container);
                headerCelda.append(container);

                // ✅ Evita que el clic en la caja dispare el ordenamiento de columnas
                input.on('click', function (e) {
                    e.stopPropagation();
                });

                input.on('keyup change clear', function () {
                    if (column.search() !== this.value) {
                        column.search(this.value).draw();
                    }
                });
            });
            document.getElementById('estado-contenedor').style.display = 'none';
        }
    });

    $('#tabla-filtros tbody').off('click', 'tr').on('click', 'tr', function() {
        const data = table.row(this).data();
        if (data) {
            abrirModalConGrafico(data);
        }
    });
}

async function abrirModalConGrafico(filaData) {
    const estadoModal = document.getElementById('estado-modal');
    const contenedorGrafico = document.getElementById('contenedor-grafico');
    const tablaFiltros = document.getElementById('tabla-filtros-grafico');
    const tablaDatosSemanas = document.getElementById('tabla-datos-semanas');
    
    if(document.getElementById('filtro-area-valor')) document.getElementById('filtro-area-valor').textContent = filaData.tp01_ct;
    if(document.getElementById('filtro-lp-valor')) document.getElementById('filtro-lp-valor').textContent = filaData.tp01_prod_line;
    if(document.getElementById('filtro-proceso-valor')) document.getElementById('filtro-proceso-valor').textContent = filaData.tp01_proceso;
    if(document.getElementById('filtro-grupo-valor')) document.getElementById('filtro-grupo-valor').textContent = filaData.tp01_producto || '-';
    if(document.getElementById('filtro-um-valor')) document.getElementById('filtro-um-valor').textContent = filaData.tp01_um;
    
    if (tablaFiltros) tablaFiltros.style.display = 'block';
    if (tablaDatosSemanas) tablaDatosSemanas.style.display = 'none'; 
    
    const modalElemento = document.getElementById('prod-modalGraficaSelector');
    if (modalElemento && window.bootstrap && bootstrap.Modal) {
        const modalInstancia = bootstrap.Modal.getInstance(modalElemento) || new bootstrap.Modal(modalElemento);
        modalInstancia.show();
    } else {
        $(modalElemento).modal('show');
    }

    if (estadoModal) {
        estadoModal.style.display = 'block';
        estadoModal.className = 'alert alert-info py-2 small';
        estadoModal.textContent = 'Cargando datos detallados del proceso...';
    }
    if (contenedorGrafico) contenedorGrafico.style.display = 'none';
    
    try {
        const token = sessionStorage.getItem('token_teresita');
        const params = new URLSearchParams({
            area: filaData.tp01_ct,
            proceso: filaData.tp01_proceso,
            lp: filaData.tp01_prod_line,
            grupo: filaData.tp01_producto || '',
            subgrupo: filaData.tp01_grupo || '',
            um: filaData.tp01_um
        });
        
        const respuesta = await fetch(`${URL_API_FILTROS}?${params}`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        });
        
        if (!respuesta.ok) throw new Error(`Error ${respuesta.status}: Falla al resolver análisis semanal`);
        
        const resultado = await respuesta.json();
        const datosOriginales = resultado.data || [];
        
        if (datosOriginales.length === 0) throw new Error('No se encontraron métricas almacenadas para este proceso.');
        
        if (estadoModal) estadoModal.style.display = 'none';
        if (contenedorGrafico) contenedorGrafico.style.display = 'block';
        
        const datosAdaptados = [];

        datosOriginales.forEach(fila => {
            const anosKeys = Object.keys(fila.todos_los_años || {});
            
            anosKeys.forEach(anoKey => {
                const anioNumero = parseInt(anoKey.replace('año_', ''));
                const semanasObjeto = fila.todos_los_años[anoKey] || {};
                
                const nuevoRenglon = {
                    tabla: "Producción",
                    nombre_campo: fila.tipo_dato === 'REAL' ? 'Producción Real' : 'Producción Promedio',
                    anio: anioNumero,
                    enero: semanasObjeto.semana_1 || semanasObjeto.semana_01 || 0,
                    febrero: semanasObjeto.semana_5 || semanasObjeto.semana_05 || 0,
                    marzo: semanasObjeto.semana_9 || semanasObjeto.semana_09 || 0,
                    abril: semanasObjeto.semana_14 || 0,
                    mayo: semanasObjeto.semana_18 || 0,
                    junio: semanasObjeto.semana_22 || 0,
                    julio: semanasObjeto.semana_27 || 0,
                    agosto: semanasObjeto.semana_31 || 0,
                    septiembre: semanasObjeto.semana_36 || 0,
                    octubre: semanasObjeto.semana_40 || 0,
                    noviembre: semanasObjeto.semana_44 || 0,
                    diciembre: semanasObjeto.semana_49 || 0
                };
                
                datosAdaptados.push(nuevoRenglon);
            });
        });

        graficaArticulos.configurarModalGrafica(datosAdaptados);

        const btnGenerar = document.getElementById('btn-gen-graf');
        if (btnGenerar) {
            const nuevoBtn = btnGenerar.cloneNode(true);
            btnGenerar.parentNode.replaceChild(nuevoBtn, btnGenerar);
            nuevoBtn.addEventListener('click', () => {
                graficaArticulos.generarGraficaArts();
            });
        }
        
    } catch (error) {
        console.error('Error al cargar datos detallados:', error);
        if (estadoModal) {
            estadoModal.className = 'alert alert-danger py-2 small';
            estadoModal.textContent = `❌ ${error.message}`;
        }
        if (tablaFiltros) tablaFiltros.style.display = 'none';
    }
}

export function generarTablaDatosSemanas(datosPorSemana) {
    const contenedorTabla = document.getElementById('tabla-datos-semanas');
    const thead = document.getElementById('thead-semanas');
    const tbody = document.getElementById('tbody-semanas');
    
    if(!thead || !tbody || !contenedorTabla) return;
    
    thead.innerHTML = '';
    tbody.innerHTML = '';
    
    const trHead = document.createElement('tr');
    trHead.innerHTML = '<th style="min-width: 60px; background-color: #f8f9fa; border: 1px solid #dee2e6;"></th>';
    
    datosPorSemana.forEach(item => {
        const th = document.createElement('th');
        th.textContent = item.label;
        th.className = 'text-center px-2';
        th.style.cssText = 'min-width: 50px; background-color: #f8f9fa; border: 1px solid #dee2e6; font-size: 10px;';
        trHead.appendChild(th);
    });
    thead.appendChild(trHead);
    
    const trReal = document.createElement('tr');
    const tdRealLabel = document.createElement('td');
    tdRealLabel.textContent = 'Real';
    tdRealLabel.className = 'fw-bold';
    tdRealLabel.style.cssText = 'background-color: rgb(31, 78, 121); color: white; border: 1px solid #dee2e6; text-align: center;';
    trReal.appendChild(tdRealLabel);
    
    datosPorSemana.forEach(item => {
        const td = document.createElement('td');
        td.textContent = item.real !== undefined ? item.real : '-';
        td.className = 'text-center';
        td.style.cssText = 'border: 1px solid #dee2e6; background-color: #fff;';
        trReal.appendChild(td);
    });
    tbody.appendChild(trReal);
    
    const trProm = document.createElement('tr');
    const tdPromLabel = document.createElement('td');
    tdPromLabel.textContent = 'Prom';
    tdPromLabel.className = 'fw-bold';
    tdPromLabel.style.cssText = 'background-color: rgb(197, 90, 17); color: white; border: 1px solid #dee2e6; text-align: center;';
    trProm.appendChild(tdPromLabel);
    
    datosPorSemana.forEach(item => {
        const td = document.createElement('td');
        td.textContent = item.prom !== undefined ? item.prom : '-';
        td.className = 'text-center';
        td.style.cssText = 'border: 1px solid #dee2e6; background-color: #fff;';
        trProm.appendChild(td);
    });
    tbody.appendChild(trProm);
    
    contenedorTabla.style.display = 'block';
}
